import { SidebarMenuItem } from "@/src/sb/business-layer/types"

const CountryMenuMock = (): Array<SidebarMenuItem> => {
  return [
    // Countries
    {
      id: 100001700,
      label: "Nigeria",
      destination: "/data/countries/nigeria",
      parent_id: 100001,
      category_name: null
    },
    {
      id: 100001710,
      label: "Kenya",
      destination: "/data/countries/kenya/",
      parent_id: 100001,
      category_name: null
    },
    {
      id: 100001720,
      label: "Ghana",
      destination: "/data/countries/ghana/",
      parent_id: 100001,
      category_name: null
    },
    {
      id: 100001730,
      label: "South Africa",
      destination: "/data/countries/south-africa/",
      parent_id: 100001,
      category_name: null
    },
    {
      id: 100001740,
      label: "Egypt",
      destination: "/data/countries/egypt/",
      parent_id: 100001,
      category_name: null
    }
  ]
}

export default CountryMenuMock
